"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("assets/styles/config");
exports.StyledButton = styled_components_1.default.button `
  font: 500 17px ${config_1.fontFamilies.primary};
  background: ${(props) => props.disabled ? config_1.colors.grayText : config_1.colors.blurple} !important;
  border-color: ${(props) => props.disabled ? config_1.colors.grayText : config_1.colors.blurple} !important;
  color: ${(props) => props.disabled ? config_1.colors.black : config_1.colors.white} !important;
  height: 43px;
  margin-top: 10px;
  width: 100%;

  &:hover,
  &:focus {
    background: ${config_1.colors.indigo};
    box-shadow: none;
  }
`;
